module.exports = __webpack_public_path__ + "img/QD.6940967d.png";